import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/grid'

import 'animate.css'
import './scss/style.scss'

import $ from 'jquery'

const device = () => {
  let ua = navigator.userAgent;
  if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0){
    return 'mobile';
  }else if(ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0){
    return 'tablet';
  }else{
    return 'desktop';
  }
}

const ww = $(window).width()

$(function(){
  if(device() === 'tablet' || ww >= 768){
    $('#viewport').attr('content', 'width=1280, user-scalable=yes')
  }
})

$(window).on('load', () => {
  $('body').addClass('is-loaded')
})

import { Swiper, Autoplay, EffectFade, Grid } from 'swiper'
Swiper.use([Autoplay, EffectFade, Grid])

//
// sliders
//

new Swiper('#fv-slider-first', {
  loop: true,
  allowTouchMove: false,
  effect: 'fade',
  speed: 2000,
  fadeEffect: {
    crossFade: true
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false
  }
})

new Swiper('#fv-slider-second', {
  loop: true,
  allowTouchMove: false,
  effect: 'fade',
  speed: 2000,
  fadeEffect: {
    crossFade: true
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false
  }
})

new Swiper('#point-slider', {
  loop: true,
  allowTouchMove: true,
  spaceBetween: 10,
  slidesPerView: 'auto',
  loopAdditionalSlides: 2,
  grid: {
    rows: 2,
  }
})

//
// parallax animations
//

// body

$(window).on('load scroll resize', () => {
  let scr = window.pageYOffset
  let threshold = $('.view-first').height()

  if(scr >= threshold){
    $(body).addClass('is-scrolled')
  } else {
    $(body).removeClass('is-scrolled')
  }
})

// in-view
import inView from 'in-view'
const h = window.innerHeight

inView.offset({
  top: 0,
  right: 0,
  bottom: (h / 4),
  left: 0
})

inView('.js-inview')
  .on('enter', el => {
    el.classList.add('go')
  })
  .on('exit', el => {
    el.classList.remove('go')
})

function inViewAnimation(animationName){
  inView(`.js-inview--${animationName}`).on('enter', el => {
    el.classList.add('animate__animated')
    el.classList.add(`animate__${animationName}`)
    el.style.opacity = 1
  })
}

inViewAnimation('flipInX');
inViewAnimation('fadeInUp');

$(window).on('load', () => {
  $('.kirin-portrait-prize01 .fv-animation--first').addClass('animate__animated')
  $('.kirin-portrait-prize01 .fv-animation--second').addClass('animate__animated')
  $('.kirin-portrait-prize01 .fv-animation--third').addClass('animate__animated')
})

$(window).on('load scroll resize', () => {
  let scr = window.pageYOffset + 175
  let offset = $('.spot').offset().top
  let spotAreaHeight = $('.spot').height()
  let spotSection = spotAreaHeight / 7

  for(let i = 0; i < 7; i++){
    if(scr >= (offset + (spotSection * i)) && scr < (offset + (spotSection * (i + 1)))){
      $(`.spot-bg-pref`).not(`:nth-child(${i + 1})`).fadeOut()
      $(`.spot-bg-pref:nth-child(${i + 1})`).fadeIn()

      $(`.spot-section`).not(`:nth-child(${i + 1})`).removeClass('is-active')
      $(`.spot-section:nth-child(${i + 1})`).addClass('is-active')
      $(`.spot-section:nth-child(${i})`).addClass('is-leave')

      let removeClassLeave = () => $(`.spot-section:nth-child(${i})`).removeClass('is-leave')
      setTimeout(removeClassLeave, 2000)
    }
  }

  $('.js-spot-scroll').on('click', () => {
    for(let i = 0; i < 7; i++){
      if(scr >= (offset + (spotSection * i)) && scr < (offset + (spotSection * (i + 1)))) spotSection = spotSection * (i + 1)
    }
    $('html, body').scrollTop(offset + spotSection)
    return false
  })
})

$(window).on('load scroll resize', () => {
  let scr = window.pageYOffset + 175
  let rfvh = $('.result-fv').height()
  if(rfvh < scr){
    $('#totop').addClass('is-active')
  } else {
    $('#totop').removeClass('is-active')
  }
})
